import { nextTick } from "vue"
import Cleave from "cleave.js"
import { debounce } from "lodash"
import tooltip from "./tooltip"

export const cleaveDirective = {
  mounted: (el, binding) => {
    el.cleave = new Cleave(el, binding.value || {})
  },
  updated: (el) => {
    const event = new Event("input", { bubbles: true })
    setTimeout(function () {
      if (el.cleave.properties.result) {
        el.value = el.cleave.properties.result
        el.rawValue = el.cleave.getRawValue()
        el.dispatchEvent(event)
      }
    }, 100)
  }
}

export const clickOutsideDirective = {
  beforeMount: function (el, binding) {
    binding.event = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        if (binding.value instanceof Function) {
          binding.value(event)
        }
      }
    }
    document.body.addEventListener("click", binding.event)
  },
  unmounted: function (el, binding) {
    document.body.removeEventListener("click", binding.event)
  }
}

export const responsiveTextDirective = {
  beforeMount(el) {
    el.style.fontSize = "clamp(1rem, calc(1rem + var(--scale-factor, 0) * 1vw), 2rem)"

    nextTick(() => {
      if (el.parentElement instanceof Element) {
        const handleResize = (entries) => {
          for (let entry of entries) {
            const width = entry.contentRect.width
            const scaleFactor = width / 1000
            el.style.setProperty("--scale-factor", scaleFactor)
          }
        }

        const ro = new ResizeObserver(handleResize)
        ro.observe(el.parentElement)
        el._resizeObserver = ro
      }
    })
  },
  unmounted(el) {
    if (el._resizeObserver) {
      el._resizeObserver.disconnect()
    }
  }
}

// Global state for drag tracking
const dragState = {
  isDragging: false
}

export const preventDragClickDirective = {
  mounted(el) {
    let startX = 0
    let startY = 0

    el.addEventListener("mousedown", (event) => {
      startX = event.clientX
      startY = event.clientY
      dragState.isDragging = true
    })

    el.addEventListener("mouseup", (event) => {
      const endX = event.clientX
      const endY = event.clientY
      const distance = Math.sqrt(Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2))

      if (distance <= 5) {
        dragState.isDragging = false
      } else {
        setTimeout(() => {
          dragState.isDragging = false
        }, 100)
      }
    })

    // Add isDragging getter to element
    Object.defineProperty(el, "isDragging", {
      get: () => dragState.isDragging
    })
  }
}

export const debounceScrollDirective = {
  beforeMount(el, binding) {
    const debouncedHandler = debounce(() => {
      const scrollPosition = el.scrollTop + el.clientHeight
      const scrollHeight = el.scrollHeight
      const threshold = scrollHeight * 0.9

      if (scrollPosition >= threshold) {
        binding.value()
      }
    }, 800)

    el.addEventListener("scroll", debouncedHandler)
  },
  beforeUnmount(el, binding) {
    el.removeEventListener("scroll", binding.value)
  }
}

export const directives = {
  cleave: cleaveDirective,
  tooltip,
  "click-outside": clickOutsideDirective,
  "responsive-text": responsiveTextDirective,
  "prevent-drag-click": preventDragClickDirective,
  "debounce-scroll": debounceScrollDirective
}

export default {
  install(app) {
    Object.entries(directives).forEach(([name, directive]) => {
      app.directive(name, directive)
    })
  }
}
